import React, { useEffect, useState } from 'react';

import EditProfileFormSection from './EditProfileFormSection';
import EditProfileFieldsName from '../../../_molecules/EditProfileFieldsName';
import EditProfileFieldsBirthdate, {
    editProfileBirthdateValidationSchema,
} from '../../../_molecules/EditProfileFieldsBirthdate';
import EditProfileFieldsGender from '../../../_molecules/EditProfileFieldsGender';
import EditProfilePictureLink from '../../../_molecules/EditProfilePictureLink';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import { DividerLightGreyStyled, Instructions } from '@styled';
import useViewer from '@hooks/useViewer';

const validationSchema = { ...editProfileBirthdateValidationSchema };

const EditProfileBasicPage = () => {
    const { viewer } = useViewer();
    const [hasBirthdate, setHasBirthdate] = useState(false);

    useEffect(() => {
        if (!viewer) return;

        if (viewer.birthdate) {
            const parts = viewer.birthdate.split('-');
            const birthdateYear = parts[0] || '';
            const birthdateMonth = parts[1] || '';
            const birthdateDay = parts[2] || '';

            if (birthdateYear && birthdateMonth && birthdateDay) {
                setHasBirthdate(true);
            }
        }
    }, [viewer]);

    return (
        <ErrorHandler>
            <TrackPageView>
                <EditProfileFormSection
                    validationSchema={validationSchema}
                    pageTitleSub="Basic Information"
                    prevNavLink="/my-icsc/account/preferences"
                    prevNavLabel="Account Preferences"
                    nextNavLink="/my-icsc/account/edit-profile/contact"
                    nextNavLabel="Contact Information"
                >
                    <DividerLightGreyStyled className="mt-3 mb-4" />
                    <h4 className="mb-0">Profile Image</h4>
                    <Instructions>
                        Your profile image is displayed on event badges, the member directory and attendee lists.
                    </Instructions>
                    <div className="d-flex justify-content-center">
                        <EditProfilePictureLink showEditIcon sizeMobile={180} sizeDesktop={180} />
                    </div>
                    <DividerLightGreyStyled className="mt-5 mb-4" />
                    <h4 className="mb-0">Name and Designations</h4>

                    <Instructions>
                        To edit your name and designations, email{' '}
                        <a className="accent" href="mailto:membership@icsc.com">
                            membership@icsc.com
                        </a>{' '}
                        or call{' '}
                        <a className="accent" href="tel:1-646-728-3800">
                            +1 646-728-3800
                        </a>
                        .
                    </Instructions>

                    <EditProfileFieldsName />
                    <DividerLightGreyStyled className="mt-5 mb-4" />
                    <h4 className="mb-0">Personal Information</h4>
                    <Instructions>
                        This information is kept confidential and is collected for demographic study only.
                    </Instructions>
                    <h5 className="mb-0">Date of Birth</h5>
                    {hasBirthdate ? (
                        <Instructions>
                            Please email{' '}
                            <a className="accent" href="mailto:membership@icsc.com">
                                membership@icsc.com
                            </a>{' '}
                            to update your birthday.
                        </Instructions>
                    ) : null}
                    <EditProfileFieldsBirthdate hasBirthdate={hasBirthdate} />
                    <h5 className="mb- mt-5">Gender</h5>
                    <EditProfileFieldsGender />
                </EditProfileFormSection>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default EditProfileBasicPage;
